import { TRACE_PARENT_HEADER } from '@opentelemetry/core';
import {
  BatchSpanProcessor,
  TraceIdRatioBasedSampler,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { B3Propagator, B3InjectEncoding } from '@opentelemetry/propagator-b3';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';

import { getResources } from '../resources';

export class Module {
  constructor(aggregator, config, otelConfig) {
    this.aggregator = aggregator;
    this.config = config;
    this.otelConfig = otelConfig;
  }

  start() {
    this.tracerProvider = new WebTracerProvider({
      sampler: new TraceIdRatioBasedSampler(this.config.sampling),
      resource: getResources(
        { ...this.config.resources, ...this.otelConfig.resources },
        this.aggregator.getSharedContext(),
        TRACE_PARENT_HEADER,
      ),
    });

    this.tracerProvider.addSpanProcessor(
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          url: this.config.url,
          headers: this.config.headers,
        }),
      ),
    );

    this.tracerProvider.register({
      propagator: new B3Propagator({
        injectEncoding: B3InjectEncoding.MULTI_HEADER, // -> B3InjectEncoding.MULTI_HEADER,
      }),
    });

    registerInstrumentations({
      tracerProvider: this.tracerProvider,
      instrumentations: [
        new FetchInstrumentation({ ignoreUrls: this.otelConfig.ignore_urls }),
        new XMLHttpRequestInstrumentation({
          ignoreUrls: this.otelConfig.ignore_urls,
        }),
      ],
    });
  }
}
